export const ShieldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 2C7.61929 2 4.9237 3.22134 3.66238 4.21019C3.16046 4.60368 3 5.24186 3 5.87963V8.30303C3 13.1515 7 18 10 18C13 18 17 13.1515 17 8.30303V5.87963C17 5.24186 16.8395 4.60368 16.3376 4.21019C15.0763 3.22134 12.3807 2 10 2Z" stroke="#34D399" strokeWidth="1.5" />
    <path d="M7.5 9.5L9.5 11.5L13.5 7.5" stroke="#34D399" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
